import useCurrentBrand from '~/hooks/useCurrentBrand';

import { AchievementListRow } from '~/types/services/agentHub';

import { mapSubject } from '~/utils/agentHub';

import { useGetAffiliation } from './useGetAffiliation';
import { useGetAgency } from './useGetAgency';
import { useGetAgentHubUser } from './useGetAgentHubUser';

export function useGetAchievementSubject(subjectType: AchievementListRow['subjectType'], subjectId: string) {
  const brand = useCurrentBrand() ?? '';
  const isAgency = subjectType === 'agency';
  const isAffiliation = subjectType === 'affiliation';
  const isAgent = subjectType === 'agent';

  const agency = useGetAgency(subjectId, { enabled: isAgency });
  const affiliation = useGetAffiliation(subjectId, { enabled: isAffiliation });
  const agent = useGetAgentHubUser(subjectId, brand, { enabled: isAgent });

  const activeQuery = isAgency ? agency : isAffiliation ? affiliation : agent;

  return {
    data: activeQuery.data ? mapSubject(activeQuery.data) : undefined,
    isFetching: activeQuery.isFetching,
    error: activeQuery.error,
  };
}
